import { styled, Box } from "@mui/material";

export const ContainerContent = styled(Box)({
  margin: "20px",
});
